import { validateText } from '../mixins/component/validateText';
import { validateNumber } from '../mixins/component/validateNumber';
import { ref, getCurrentInstance, computed, watch } from 'vue';
import { validateCombobox } from '../mixins/component/validateCombobox';
import { ModuleBudgetSource, ModuleAccountCombo, ModuleTARiskCustomerVendor, ModuleOrganizationHaveRisk } from '@/stores/moduleConst';
import i18nValidate from '@/i18ns/vi/i18nValidate';
import integrationBIApi from '@/apis/integration/integrationBusinessInformationApi.js';

export const useValidateControl = ({ props }) => {
  const errorMessage = ref('');
  const displayError = ref(true);
  const displayErrorMissingValue = ref(false);
  const isValidate = computed(() => props.rules.length > 0);
  const riskWarningCustomerVendorMessage = ref({});
  const isShowQuestionIcon = ref(false);
  const riskWarningMessage = ref({});
  const { proxy } = getCurrentInstance();
  const validate = (hasValidateSave, triggerDisplayError) => {
    const controlValue = getValueControl();
    //Nếu là editor của grid thì sẽ lấy config từ column
    let rules = [];
    if (proxy._isGridEditor) {
      rules = props.disabledValidate ? [] : props.col.rules;
    } else {
      rules = props.rules;
    }
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const { name, compareValue, customValidate } = rule;
          //Nếu có custom validate sẽ lấy theo customvalidate
          if (customValidate && typeof customValidate === 'function') {
            message = customValidate(controlValue, compareValue, getTitleError(), props.dataRow, props.col);

            if (customValidate.name == 'validateRiskCustomerVendor' && typeof message !== undefined) {
              riskWarningCustomerVendorMessage.value = JSON.parse(message);
              message = JSON.parse(message).text;
              isShowQuestionIcon.value = true;
              errorMessage.value = message;
              return false;
            } else {
              isShowQuestionIcon.value = false;
            }

            if (message) {
              break;
            }
          } else {
            message = handlerRule(
              name,
              controlValue,
              compareValue,
              hasValidateSave,
              triggerDisplayError,
              props.dataRow
            );
            if (message) {
              break;
            }
          }
        }
      }
    }


    // dtnga3 (05.06.2024) validate maxlength cho ô input thường
    if(!message && !props.isGridEditor && props.maxLength > 0 && controlValue && controlValue.length > props.maxLength){
      message = i18nValidate.messages.GreaterThanMaxLength(props.maxLength);
    }
    errorMessage.value = message;
    if (props.validateMissingValue && message) {
      return getTitleError();
    }

    return message;
  };
  /**
   * Xử lý các rule validate
   * @param {*} rule tên rule
   * @param {*} compareValue value
   * @returns
   */
  const handlerRule = (rule, controlValue, compareValue, hasValidateSave, triggerDisplayError, dataRow) => {
    let message = '';

    const titleError = getTitleError();
    switch (rule) {
      case 'required':
        if (controlValue === undefined || controlValue === null || controlValue === NaN || controlValue === '') {
          message = i18nValidate.messages[rule](titleError, proxy._isGridEditor);
        }
        break;
      case 'moreThan':
        break;
      case 'lessThan':
        break;
      case 'lessThanAmount':
        if (
          controlValue !== undefined &&
          controlValue !== null &&
          !isNaN(controlValue) &&
          compareValue !== undefined &&
          compareValue !== null &&
          !isNaN(compareValue)
        ) {
          // Chuyển về BigInt để khi so sánh tránh trường hợp 1e21 (NHANH3 15.11.2023)
          let numberValue = Number.isInteger(controlValue) != true ? parseInt(controlValue) : controlValue;
          let numberCompare = Number.isInteger(compareValue) != true ? parseInt(compareValue) : compareValue;
          if (numberValue > 0) {
            if (BigInt(numberValue) >= BigInt(numberCompare)) {
              message = i18nValidate.messages[rule](titleError, BigInt(numberCompare).toString().length);
            }
          } else {
            if (BigInt(numberValue) <= BigInt(numberCompare * -1)) {
              message = i18nValidate.messages[rule](titleError, BigInt(numberCompare).toString().length);
            }
          }
        }
        break;
      case 'equals':
        break;
      case 'pattern':
        if (!validateText.validateRule(compareValue, controlValue)) {
          message = i18nValidate.messages['email'](titleError);
        }
        break;
      case 'tax':
        if (!validateText.validateRule(compareValue, controlValue)) {
          message = i18nValidate.messages['taxCode'](titleError);
        }
        break;
      case 'diffierentZero':
        if (!validateNumber.validatediffierentZero(controlValue)) {
          message = i18nValidate.messages['diffierentZero'](titleError);
        }
        break;
      case 'greaterThanZero':
        if (!validateNumber.validategreaterThanZero(controlValue)) {
          message = i18nValidate.messages['greaterThanZero'](titleError);
        }
        break;
      case 'missingValue':
        if (
          (controlValue === undefined ||
            controlValue === null ||
            controlValue === NaN ||
            controlValue === '' ||
            controlValue === 0) &&
          hasValidateSave
        ) {
          if (triggerDisplayError) {
            displayError.value = true;
          } else {
            displayError.value = false;
          }
          if (hasValidateSave) {
            displayErrorMissingValue.value = true;
          }
          message = i18nValidate.messages[rule](titleError, proxy._isGridEditor);
        } else {
          displayErrorMissingValue.value = false;
        }
        break;
      case 'riskCustomerVendor':
        message = validateCombobox.validateRule('riskCustomerVendor', proxy, hasValidateSave || displayErrorMissingValue.value);
        message = JSON.parse(message).text;
        break;
      default:
        break;
    }
    return message;
  };


  /**
   * Xử lý validate riêng cho combobox
   */
  const handlerValidateCombobox = (hasValidateSave, triggerDisplayError) => {
    const { rules } = props;
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const { name, compareValue, customValidate } = rule;
          message = validateCombobox.validateRule(name, proxy, hasValidateSave || displayErrorMissingValue.value, compareValue, customValidate);

          if (name == 'missingValue' && message) {
            if (hasValidateSave) {
              displayErrorMissingValue.value = true;
            }

            if (triggerDisplayError) {
              displayError.value = true;
            } else {
              displayError.value = false;
            }
          } else {
            displayError.value = true;
            displayErrorMissingValue.value = false;
          }
          if (name == 'riskCustomerVendor' && message) {
            isShowQuestionIcon.value = true;
          } else {
            isShowQuestionIcon.value = false;
          }
          if (message) {
            break;
          }
        }
      }
    }

    errorMessage.value = message;

    return message;
  };

  const clearValidate = () => {
    errorMessage.value = '';
  };
  /**
   * Lấy value của control (Các control override hàm này)
   * @returns
   */
  const getValueControl = () => {
    return proxy.getValue();
  };

  /**
   * Lấy title của error
   * @returns
   */
  const getTitleError = () => {
    const { title } = props;
    if (proxy._isGridEditor) {
      return props.col.caption;
    }
    return title || getValidateName();
  };

  /**
   * Nếu control không khai báo name để hiển thị thông tin lỗi validate -> up parent find label
   */
  const getValidateName = () => {
    let fn = function (el, c) {
      if (!el || c > 10) {
        return null;
      }

      let labelEl = el.querySelector('label');
      if (labelEl) {
        return (labelEl.innerText || '').replace('*', '');
      }

      return fn(el.parentNode, c + 1);
    };

    return fn(proxy.$el, 0);
  };
  /**
   * Kiểm tra chuỗi có phải dạng JSON hay không
   */
  const isJSON = (str) => {
    try {
      if (str) {
        JSON.parse(str);
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
  /**
   * Validate khách hàng, nhà cung cấp rủi ro
   * NBTIN 31.01.2024
   */
  async function validateRiskCustomerVendor(rule, me) {
    try {
      if (!me) {
        return;
      }
      var message = {};
      var itemSelected = me;
      // select ra combobox cần validate (ở chứng từ và danh mục)
      // for (const refKey in proxy.$refs) {
      //   if (refKey.startsWith('customerVendor')) {
      //     if(proxy.$refs[refKey]?.internalSelectedItem?.company_tax_code == proxy.model.company_tax_code || proxy.$refs[refKey]?.internalSelectedItem?.taxCode == proxy.model.company_tax_code){
      //       itemSelected = proxy.$refs[refKey];
      //       break;
      //     }
      //   }
      // }
      // Thực hiện kiểm tra rủi ro
      var notActiveTaxCustomerVendor = false;
      if (itemSelected.validate()) {
        isShowQuestionIcon.value = false;
        return;
      }
      var valueTaxCode = itemSelected?.internalSelectedItem?.company_tax_code;
      if(!valueTaxCode){
        return;
      }
      var customerVendorInfomations = await integrationBIApi.getBusinessInformationLookUp(valueTaxCode, true);
      if (customerVendorInfomations.activeStatus == proxy.$t('i18nEnum.TaxActiveStatus.NotActive') ||
        customerVendorInfomations.activeStatus == proxy.$t('i18nEnum.TaxActiveStatus.NotActiveButNotCompleteProcedure') ||
        customerVendorInfomations.activeStatus == proxy.$t('i18nEnum.TaxActiveStatus.TemporaryBreakBusiness') ||
        customerVendorInfomations.activeStatus == proxy.$t('i18nEnum.TaxActiveStatus.NotActiveButNotCompleteProcedureDN')
      ) {
        notActiveTaxCustomerVendor = true;
      }
      var riskCustomerVendor = customerVendorInfomations.is_has_rick;

      // Gán câu thông báo theo từng loại rủi ro và tình trạng ngừng hoạt động
      if (notActiveTaxCustomerVendor && !riskCustomerVendor) {
        message.text = i18nValidate.messages[rule](proxy.$ms.constant.RiskCustomerVendorType.NoneActivity);
        message.riskType = proxy.$ms.constant.RiskCustomerVendorType.NoneActivity;
        message.closedDate = customerVendorInfomations.closedDate;
        message.modifiedDate = customerVendorInfomations.modifiedDate;
      } else if (!notActiveTaxCustomerVendor && riskCustomerVendor) {
        message.text = i18nValidate.messages[rule](proxy.$ms.constant.RiskCustomerVendorType.RiskInvoice);
        message.riskType = proxy.$ms.constant.RiskCustomerVendorType.RiskInvoice;
        message.document_name = customerVendorInfomations.rick_document_name;
        message.closedDate = customerVendorInfomations.closedDate;
        message.modifiedDate = customerVendorInfomations.modifiedDate;
      } else if (notActiveTaxCustomerVendor && riskCustomerVendor) {
        message.text = i18nValidate.messages[rule](proxy.$ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce);
        message.riskType = proxy.$ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce;
        message.document_name = customerVendorInfomations.rick_document_name;
        message.closedDate = customerVendorInfomations.closedDate;
        message.modifiedDate = customerVendorInfomations.modifiedDate;
      } else {
        message.text = i18nValidate.messages[rule](proxy.$ms.constant.RiskCustomerVendorType.None);
        message.riskType = proxy.$ms.constant.RiskCustomerVendorType.None;
      }
      // Hiện câu thông báo
      if (message) {
        riskWarningMessage.value = message;
        // for (const refKey in proxy.$refs) {
        //   if (refKey.startsWith('customerVendor')) {
        //     if(proxy.$refs[refKey]?.internalSelectedItem?.company_tax_code == proxy.model.company_tax_code || proxy.$refs[refKey]?.internalSelectedItem?.taxCode == proxy.model.company_tax_code ){
        //       proxy.$refs[refKey].errorMessage = riskWarningMessage.value.text;
        //     }
        //   }
        // }
        itemSelected.errorMessage = riskWarningMessage.value.text;
        isShowQuestionIcon.value = true;
        return false;
      } else {
        isShowQuestionIcon.value = false;
      }
      return message;
    }
    catch (err) {
      console.log(err);
    }
  }
  return {
    errorMessage,
    validate,
    handlerValidateCombobox,
    getTitleError,
    clearValidate,
    isValidate,
    displayError,
    getValidateName,
    displayErrorMissingValue,
    riskWarningCustomerVendorMessage,
    riskWarningMessage,
    isShowQuestionIcon,
    isJSON,
    validateRiskCustomerVendor,
  };
};
